import axios from 'axios';
import {
  EVENTS_LOAD_SNIPPETS_IN_EVENT_BEGIN,
  EVENTS_LOAD_SNIPPETS_IN_EVENT_SUCCESS,
  EVENTS_LOAD_SNIPPETS_IN_EVENT_FAILURE,
  EVENTS_LOAD_SNIPPETS_IN_EVENT_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadSnippetsInEvent(args = {}) {
  return (dispatch) => {
    dispatch({
      type: EVENTS_LOAD_SNIPPETS_IN_EVENT_BEGIN,
    });

    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/min/snippet-templates`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: EVENTS_LOAD_SNIPPETS_IN_EVENT_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: EVENTS_LOAD_SNIPPETS_IN_EVENT_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadSnippetsInEventError() {
  return {
    type: EVENTS_LOAD_SNIPPETS_IN_EVENT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EVENTS_LOAD_SNIPPETS_IN_EVENT_BEGIN:
      return {
        ...state,
        loadSnippetsInEventPending: true,
        loadSnippetsInEventError: null,
      };

    case EVENTS_LOAD_SNIPPETS_IN_EVENT_SUCCESS:
      return {
        ...state,
        loadSnippetsInEventPending: false,
        loadSnippetsInEventError: null,
        snippets: action.data,
      };

    case EVENTS_LOAD_SNIPPETS_IN_EVENT_FAILURE:
      return {
        ...state,
        loadSnippetsInEventPending: false,
        loadSnippetsInEventError: action.data.error,
      };

    case EVENTS_LOAD_SNIPPETS_IN_EVENT_DISMISS_ERROR:
      return {
        ...state,
        loadSnippetsInEventError: null,
      };

    default:
      return state;
  }
}
